import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
export default function AddUserToMailGroup({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.EWS.";

    return (
        <div>
            <div className="form-element">
                {t(label + "GROUP-NAME")}
                <TextInput
                    action={action}
                    inputName="groupName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>

            <div className="form-element">
                {t(label + "USERNAME")}
                <TextInput
                    action={action}
                    inputName="userName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>



        </div>
    );
}

